import { render } from "./USRComponentList.vue?vue&type=template&id=81c87114"
import script from "./USRComponentList.vue?vue&type=script&lang=ts"
export * from "./USRComponentList.vue?vue&type=script&lang=ts"
script.render = render

export default script